import React from 'react';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { SiteFooter } from '../components/ui/SiteFooter';
import { FoundingOffer } from '../components/practitioners/FoundingOffer';
import { foundingOffer } from '../data/foundingOffer';
export function PractitionersPage() {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-676" data-mp="2zcs4mzp2h93l">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-677" data-mp="3w1zjjov6kjyj">
        <a href="/" aria-label="Fem Entity home" data-id="element-678" data-mp="3n0rw61u7d3j8">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-679" data-mp="3n3nuhr9ypu87" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-680" data-mp="2bkbcfwbm80qk">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-681" data-mp="26pnxop6eykp6">
            Home
          </a>
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-682" data-mp="zjjb1z3x8vuw">
            Download the App
          </a>
          <a href="/practitioners" className="text-purple-700 font-semibold" data-id="element-683" data-mp="pmenbuufgsbz">
            Practitioners
          </a>
        </div>
      </nav>

      <main className="pt-16 md:pt-24 pb-24" data-id="element-684" data-mp="fxem04sgdkum">
        {/* Intro */}
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-685" data-mp="fw3im62x6f41">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-5" data-id="element-686" data-mp="kod3v8t3aqzz">
            For Practitioners
          </p>
          <h1 className="font-serif text-4xl md:text-6xl text-charcoal leading-[1.05] mb-6 tracking-tight" data-id="element-687" data-mp="6yjcaiq79smk">
            Join the Network
          </h1>
          <p className="text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-688" data-mp="3t3n1a3m1b81f">
            Become part of a curated community of trusted practitioners shaping
            the future of women's wellness.
          </p>
        </div>

        {/* Founding member offer */}
        <div className="max-w-3xl mx-auto px-6 mt-10" data-id="element-689" data-mp="3a7y133jc4ci5">
          <div className="rounded-3xl bg-purple-800 px-7 py-8 md:px-10 md:py-9 text-center" data-id="element-690" data-mp="3a63b3at7hu77">
            <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-purple-200" data-id="element-691" data-mp="35935t246kvh5">
              <SparklesIcon aria-hidden="true" className="w-4 h-4" data-id="element-692" data-mp="307nmpflkcz1e" />
              Founding member offer
            </p>
            <p className="mt-4 font-serif text-2xl md:text-3xl text-white leading-snug" data-id="element-693" data-mp="3syfg65b8v9l1">
              {foundingOffer.headline}
            </p>
            <p className="mt-4 text-base text-purple-100/90 leading-relaxed max-w-xl mx-auto" data-id="element-694" data-mp="3nxhwtpei09hy">
              {foundingOffer.subline}
            </p>
            <p className="mt-5 text-sm text-purple-200/80" data-id="element-695" data-mp="2cjnwqhw2tcnv">
              Offer closes {foundingOffer.deadline}.
            </p>
            <a href="/practitioners/join" className="mt-7 inline-flex items-center justify-center rounded-full bg-white px-8 py-3.5 text-base font-semibold text-purple-900 transition-colors duration-200 ease-out hover:bg-purple-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-200 focus-visible:ring-offset-2 focus-visible:ring-offset-purple-800" data-id="element-696" data-mp="27jrrygfk1h79">
              Join Fem Entity
            </a>
          </div>
        </div>

        {/* Offer detail */}
        <div className="max-w-3xl mx-auto px-6 mt-20 md:mt-24" data-id="element-697" data-mp="16q83udcrt9ly">
          <FoundingOffer data-id="element-698" data-mp="1arlcev78zqwk" />
        </div>

        {/* Application form */}
        <section id="apply" aria-labelledby="apply-heading" className="max-w-3xl mx-auto px-6 mt-20 md:mt-24 scroll-mt-28" data-id="element-699" data-mp="1frg24vfaeag1">
          <div className="rounded-3xl border border-purple-200 bg-white px-7 py-10 md:px-12 md:py-12 text-center shadow-[0_18px_50px_-30px_rgba(44,44,44,0.5)]" data-id="element-700" data-mp="1kprd59hbiqzu">
            <h2 id="apply-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-701" data-mp="3mh456xy6t4eh">
              Ready to join?
            </h2>
            <p className="mt-4 max-w-xl mx-auto text-base text-charcoal/70 leading-relaxed" data-id="element-702" data-mp="1bv20p8r1102p">
              Create your account and choose your membership here, then complete
              your practitioner profile and verification in the Fem Entity app.
            </p>
            <a href="/practitioners/join" className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-purple-700 px-8 py-4 text-base font-semibold text-white transition-colors duration-200 ease-out hover:bg-purple-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-703" data-mp="y358l4pcyq6b">
              Join Fem Entity
              <ArrowRightIcon aria-hidden="true" className="w-4 h-4" data-id="element-704" data-mp="ee39ntouvuoo" />
            </a>
          </div>
        </section>
      </main>

      <SiteFooter currentPath="/practitioners" data-id="element-705" data-mp="abgna8ayf1yv" />
    </div>;
}